export default __webpack_public_path__ + "static/media/arrow-left-solid.41b14f51.svg";